// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.daemon-default>.list-item{background-color:var(--color-background-dark)}`, "",{"version":3,"sources":["webpack://./src/components/DaemonConfig/DaemonConfig.vue"],"names":[],"mappings":"AACA,2BACC,6CAAA","sourcesContent":["\n.daemon-default > .list-item {\n\tbackground-color: var(--color-background-dark);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
